export const BUYER_PERSONAS_SET = "BUYER_PERSONAS_SET";
export const BUYER_PERSONAS_DELETE = "BUYER_PERSONAS_DELETE";
